module.exports = __webpack_public_path__ + "img/form-settings-background.2042a928.svg";